import qs from 'qs';
import { api } from 'src/api/api';

export async function saveTableColumnsPreferences(data: any) {
  const { data: response } = await api.post(
    '/wallet-monitor-user-table-columns-preference/create',
    data,
  );
  return response;
}

export async function getTableColumnsPreferences(data: any) {
  const { data: response } = await api.get(
    '/wallet-monitor-user-table-columns-preference/find-by-user',
  );
  return response;
}

export async function saveWalletTableColumnsPreferences(data: any) {
  const { data: response } = await api.post(
    '/wallet-table-columns-preference/create',
    data,
  );
  return response;
}

export async function getWalletTableColumnsPreferences(walletId: number) {
  const query = qs.stringify({
    walletId,
  });
  const { data: response } = await api.get(
    `/wallet-table-columns-preference/find-by-wallet-id?${query}`,
  );
  return response;
}

export async function deleteTableColumnsPreferences(id: number) {
  const { data: response } = await api.delete(
    `/wallet-monitor-user-table-columns-preferences/${id}`,
  );
  return response;
}
